define("@ember/runloop/type-tests.ts/begin-end.test", ["@ember/runloop", "expect-type"], function (_runloop, _expectType) {
  "use strict";

  (0, _expectType.expectTypeOf)((0, _runloop.begin)()).toEqualTypeOf(); // code to be executed within a RunLoop

  (0, _expectType.expectTypeOf)((0, _runloop.end)()).toEqualTypeOf();
});